var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarkerTime = function SvgMarkerTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    "data-name": "Layer 1",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c3c3c3",
    d: "M12 24a5.42 5.42 0 0 1-3.808-1.552L4.25 18.805A11 11 0 1 1 19.777 3.222a11 11 0 0 1 0 15.556l-3.991 3.689A5.4 5.4 0 0 1 12 24m0-22a9 9 0 0 0-6.364 15.364L9.57 21a3.516 3.516 0 0 0 4.838.019l3.984-3.682a9 9 0 0 0-.029-12.7A8.94 8.94 0 0 0 12 2m0 16a7 7 0 1 1 7-7 7.01 7.01 0 0 1-7 7m0-12a5 5 0 1 0 5 5 5.006 5.006 0 0 0-5-5m1.707 6.707a1 1 0 0 0 0-1.414L13 10.586V9a1 1 0 0 0-2 0v2a1 1 0 0 0 .293.707l1 1a1 1 0 0 0 1.414 0"
  })));
};
export default SvgMarkerTime;